import React from 'react'
import {i} from '../../i'
import download from '../util/svg/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'

export default class Products extends React.Component {
  state={}
  render() {
    return (
      <section className="hero text-center">
        <div className="container-sm">
          <div className="hero-inner">
            <div className="hero-browser-inner is-revealing products">
              <div className="row">
                {
                  i.products.map((e,i)=>(
                    <div key={i} className="col-6">
                      <h3>{e.name}</h3>
                      <p>{e.description}</p>
                      <div className="row">
                        <div className="col-4">
                          <img src={e.icon} alt="" className="app-icon float-right mr-3" width="65%" />
                        </div>
                        <div className="col-8">
                          <a href={e.url} target="_blank">
                            <img src={download} alt="Download from the App Store" width="100%" />
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/section/Products.js